import React from 'react'
import OperationWorkflowModal from 'common/components/OperationWorkflowModal'
import API from 'common/logic/API'
import { Button, Form } from 'react-bootstrap'
import { Formik } from 'formik'
import * as yup from 'yup'

interface Props {
    onSuccess: (result: unknown) => void
    entryId?: number
}

function EditTagWorkflow({ onSuccess, entryId }: Props) {

    const loadingStep = (_parameters: unknown) => {
        if (entryId !== undefined) {
            return API.get(`/tags/${entryId}`).then((r: any) => r.data)
        }
        return Promise.resolve(null)
    }

    const userInputStep = (_parameters: unknown, loading_result: unknown, _values: unknown, _errors: unknown, completion: (input: unknown) => void) => {
        const entry = loading_result as any
        return {
            component: <FormInner entry={entry} completion={completion} />,
            title: entryId ? 'Edit tag' : 'New tag'
        }
    }

    const executionStep = (_parameters: unknown, _loading_result: unknown, user_input: unknown) => {
        if (entryId) {
            return API.put(`/tags/${entryId}`, user_input)
        } else {
            return API.post('/tags', user_input)
        }
    }

    return (
        <OperationWorkflowModal
            loadingStep={loadingStep}
            userInputStep={userInputStep}
            executionStep={executionStep}
            completionCallback={onSuccess}
        />
    )
}

interface FormInnerProps {
    entry: any
    completion: (input: unknown) => void
}

function FormInner({ entry, completion }: FormInnerProps) {
    const schema = yup.object().shape({
        name: yup.string().required().trim()
    })

    const initialValues = { name: entry?.name ?? '' }

    return (
        <Formik validationSchema={schema} onSubmit={values => completion({ name: values.name.trim() })} initialValues={initialValues}>
            {({ handleSubmit, handleChange, values, errors }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group controlId="formName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            placeholder="Tag name"
                            value={values.name}
                            onChange={handleChange}
                            isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary" type="submit">Save</Button>
                </Form>
            )}
        </Formik>
    )
}

export default EditTagWorkflow
